export const isTest=false;

//region:the user pool/s3 region
//IdentityPoolId: identity pool id
// UserPoolId: user pool id
// ClientId: app client id (under the user pool)
export const Cognito={
    region: 'us-east-1',
    IdentityPoolId: 'us-east-1:34ffc1d9-b261-4ea3-9712-f0cec8bf0fcb',
    UserPoolId: 'us-east-1_c1857mbEf',
    ClientId: '77g1hf7rsl28jmn0sk0tvdvdql',
}

//bucketName: s3 bucket name
//apiEndPoint: api gateway endpoint url
export const S3={
    bucketName:'cloud-image-20170101',
    apiEndPoint:'https://58sjzjgip5.execute-api.us-east-1.amazonaws.com/production/pepboys-lambda'
}



// WEBPACK FOOTER //
// ./src/config/index.js